export function Footer() {
  return (
    <div className="text-center text-sm text-gray-500 mt-16 pb-16">
      <p>CNE Força de Vendas</p>
      <p>© {new Date().getFullYear()} - Todos os direitos reservados</p>
    </div>
  )
}
